<template>
    <!-- <layout title="プッシュ通知"> -->
        <div>
                <button type="button" v-on:click="subscribe" v-if="!isSubscribed">イベントのプッシュ通知を登録する</button>
                <div v-else>
                    <button type="button" v-on:click="unsubscribe">イベントのプッシュ通知を解除する</button><br>
                    <button type="button" v-on:click="webPush">プッシュ通知をする</button>
                </div>
        </div>
        <AlertModal 
            v-if="showAlertModal" 
            @close="closeAlertModal" 
            :title="alert_modal_title" 
            :message="alert_modal_message"
            :mode="alert_modal_mode" 
        />
    <!-- </layout> -->
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'

    export default {
        // layout: AdminLayout,
        components: {
            "AlertModal": AlertModal,
        },
        data: function() {
            return {
                vapidPublicKey: process.env.MIX_VAPID_PUBLIC_KEY,
                registration: null,
                isSubscribed: false,
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        methods: {
            webPush() {   // プッシュ通知をする
                this.$inertia.visit('/back-door/web_push', { method: 'post' })
            },
            subscribe() {   // プッシュ通知を許可する

                const applicationServerKey = this.base64toUint8(this.vapidPublicKey);
                const options = {
                    userVisibleOnly: true,
                    applicationServerKey: applicationServerKey
                };
                this.registration.pushManager.subscribe(options)
                    .then(subscription => {

                        // Laravel側へデータを送信
                        this.$inertia.visit('/back-door/web_push/store',{
                            method: 'post',
                            data: JSON.stringify(subscription),
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            }
                        })
                        this.isSubscribed = true;
                        this.openAlertModal('success', '登録完了', 'プッシュ通知が登録されました。');
                    })
                    .catch((error)=> {
                        this.openAlertModal('error', 'エラー', '設定の通知を許可してください。');
                    })
                    .finally(() => {
                    });
            },
            unsubscribe() { // プッシュ通知を解除する
                this.registration.pushManager.getSubscription()
                    .then(subscription => {
                        subscription.unsubscribe()
                            .then(result => {
                                if(result) {
                                    this.isSubscribed = false;
                                    this.openAlertModal('success', '通知解除', 'プッシュ通知が解除されました。');
                                }
                            });
                    })
                    .finally(() => {
                    });
            },
            base64toUint8(str) {
                str += '='.repeat((4 - str.length % 4) % 4);
                const base64 = str
                    .replace(new RegExp('\-', 'g'), '+')
                    .replace(new RegExp('_', 'g'), '/');

                const binary = window.atob(base64);
                const binaryLength = binary.length;
                let uint8Array = new Uint8Array(binaryLength);

                for(let i = 0; i < binaryLength; i++) {
                    uint8Array[i] = binary.charCodeAt(i);
                }
                return uint8Array.buffer;
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            }
        },
        mounted() {
            if('serviceWorker' in navigator && 'PushManager' in window) {
                // Service Workerをブラウザにインストールする
                navigator.serviceWorker.register('/service-worker.js')
                    .then(registration => {
                        console.log('Service Worker が登録されました。');
                        this.registration = registration;
                        this.registration.pushManager.getSubscription()
                            .then(subscription => {
                                this.isSubscribed = !(subscription === null);
                            });
                    });
            } else {
                console.log('このブラウザは、プッシュ通知をサポートしていません。');
            }
        }
    }
</script>
